// extracted by mini-css-extract-plugin
export default {"cls1":"VeloTabbedView-Error_cls1__7An9+","cls2":"VeloTabbedView-Error_cls2__TkNPD VeloTabbedView-Error_cls1__7An9+"};